export default function Products() {
  return (
    <div className="maincontainer-sm row">
      <div className="col home-body">
        <h1>Coming soon!</h1>
      </div>
    </div>
  );
}
